import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

import firebaseConfigs from "../firebaseConfig.json";

const databaseId = "(default)";

// Determine which Firebase environment to use: "sandbox" (default) or "live"
const firebaseEnv = process.env.REACT_APP_FIREBASE_ENV === "live" ? "live" : "sandbox";
const firebaseConfig = firebaseConfigs[firebaseEnv];

// Reuse an existing app if one is already initialized (e.g. in tests)
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const firestore = getFirestore(app, databaseId);
export const storage = getStorage(app);